import { render, staticRenderFns } from "./VendorInfo.vue?vue&type=template&id=2fd0faa6"
import script from "./VendorInfo.vue?vue&type=script&lang=js"
export * from "./VendorInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports